import { notNull } from '~/_shared/utils/typeGuards';
import { ActiveDataLayerContainer } from '~/sidebar/sidebarApps/mapTools/dataLayersTool/listing/activeDataLayer.container';
import { useDataLayersToolBTGsGroupedByBoundaryGroupSelector } from '~/store/boundaryTerritoryGroups/dataLayersTool/dataLayersBTGs.selectors';
import { isBTGForDataLayer } from '~/store/boundaryTerritoryGroups/dataLayersTool/dataLayersToolBTGs.helpers';
import { useMapSettingsDataLayerGroupsSelector } from '~/store/mapSettings/data/dataLayers/mapSettingsDataLayers.selectors';

export const DataLayersToolListingContainer = () => {
  const boundaryTerritoryGroupsByBoundaryGroupId = useDataLayersToolBTGsGroupedByBoundaryGroupSelector();
  const dataLayerGroups = useMapSettingsDataLayerGroupsSelector();

  return (
    <>
      {boundaryTerritoryGroupsByBoundaryGroupId
        .map(({ boundaryGroupId, boundaryTerritoryGroups }) => {
          const firstGroup = boundaryTerritoryGroups[0] || boundaryTerritoryGroups[1];

          if (!firstGroup) {
            return null;
          }

          const dataLayerGroup = dataLayerGroups.find(dl => isBTGForDataLayer(dl.id, firstGroup));

          if (!dataLayerGroup) {
            return null;
          }

          return (
            <ActiveDataLayerContainer
              key={boundaryGroupId}
              boundaryGroupId={boundaryGroupId}
              boundaryTerritoryGroups={boundaryTerritoryGroups}
              dataLayerGroup={dataLayerGroup}
            />
          );
        }).filter(notNull)}
    </>
  );
};
